import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { AwarenessSection } from '../components/AwarenessSection';
import { AboutSection } from '../components/AboutSection';
import { Method3S } from '../components/Method3S';
import { ServicesSection } from '../components/ServicesSection';
import { FreeSessionCTA } from '../components/FreeSessionCTA';
import { ResourcesSection } from '../components/ResourcesSection';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-brand-bg font-sans text-brand-text selection:bg-brand-primary/20" data-id="element-211">
      <Navbar data-id="element-212" />
      <main data-id="element-213">
        <Hero data-id="element-214" />
        <AwarenessSection data-id="element-215" />
        <AboutSection data-id="element-216" />
        <Method3S data-id="element-217" />
        <ServicesSection data-id="element-218" />
        <FreeSessionCTA data-id="element-219" />
        <ResourcesSection data-id="element-220" />
        <Testimonials data-id="element-221" />
        <FAQ data-id="element-222" />
      </main>
      <Footer data-id="element-223" />
    </div>;
}